// src/components/gen-application/genValidators.js

// const SIN_REGEX = /^\d{3}-\d{3}-\d{3}$/;
const PEN_REGEX = /^\d{9}$/;
const PHONE_REGEX =
  /^(\(\d{3}\)\s?\d{3}-\d{4}|\d{3}\s\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{3}\s\d{7}|\d{10})$/;

function normalizeSIN(sin) {
  return sin?.replace(/\D/g, "");
}

function luhnCheck(sinDigits) {
  let sum = 0;
  let alternate = false;

  for (let i = sinDigits?.length - 1; i >= 0; i--) {
    let digit = parseInt(sinDigits[i], 10);
    if (alternate) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
    alternate = !alternate;
  }

  return sum % 10 === 0;
}

const knownInvalidSINs = new Set(["000000000", "111111111", "123456789"]);

function isValidSIN(sin) {
  if (!sin) return false;
  const sinDigits = normalizeSIN(sin);
  if (sinDigits.length !== 9) return false;
  if (knownInvalidSINs.has(sinDigits)) return false;
  return luhnCheck(sinDigits);
}

export const validateStep1 = (fd) => {
  const errors = {};

  if (!fd.firstName?.trim()) {
    errors.firstName = "First Name is required.";
  }
  if (!fd.lastName?.trim()) {
    errors.lastName = "Last Name is required.";
  }
  if (!fd.dob) {
    errors.dob = "Date of Birth is required.";
  }
  if (!fd.address?.trim()) {
    errors.address = "Mailing Address is required.";
  }
  if (!fd.city?.trim()) {
    errors.city = "City is required.";
  }
  if (!fd.province?.trim()) {
    errors.province = "Province is required.";
  }
  if (!fd.postalCode?.trim()) {
    errors.postalCode = "Postal Code is required.";
  }

  if (!fd.SIN || !isValidSIN(fd.SIN)) {
    errors.SIN = "Invalid SIN. Please enter a valid 9-digit SIN.";
  }
  if (!fd.PEN?.match(PEN_REGEX)) {
    errors.PEN = "Invalid PEN. Must be 9 digits.";
  }
  if (
    (!fd.cellPhone && !fd.cellPhone.match(PHONE_REGEX)) ||
    (fd.cellPhone && !fd.cellPhone.match(PHONE_REGEX))
  ) {
    errors.cellPhone = "Invalid Cell Phone format.";
  }
  if (fd.homePhone && !fd.homePhone.match(PHONE_REGEX)) {
    errors.homePhone = "Invalid Home Phone format.";
  }
  if (fd.workPhone && !fd.workPhone.match(PHONE_REGEX)) {
    errors.workPhone = "Invalid Work Phone format.";
  }

  return errors;
};

export const validateStep2 = (fd) => {
  const errors = {};

  if (!fd.careerJobDirection?.trim()) {
    errors.careerJobDirection = "Career/Job Direction is required.";
  }

  if (!fd.directToPostSecondary) {
    errors.directToPostSecondary =
      "Please select Yes or No for Post Secondary.";
  }

  if (fd.directToPostSecondary === "No") {
    if (!fd.postSecondaryWhen?.trim()) {
      errors.postSecondaryWhen =
        "Please indicate when you plan to attend post secondary.";
    }
  }

  if (fd.PS_Path === "Other" && !fd.PS_Path_Other?.trim()) {
    errors.PS_Path_Other = "Please specify your Post Secondary Path details.";
  }

  if (fd.fieldOfStudy === "--Other--" && !fd.fieldOfStudyOther?.trim()) {
    errors.fieldOfStudyOther = "Please specify your field of study details.";
  }

  if (!fd.PS_Program_Name?.trim()) {
    errors.PS_Program_Name = "Program Name is required.";
  }

  if (!fd.academicSignedDate) {
    errors.academicSignedDate = "Signed Date is required.";
  }
  if (!fd.academicSignedName?.trim()) {
    errors.academicSignedName = "Signed Name is required.";
  }

  return errors;
};

export const validateStep3 = (fd) => {
  const errors = {};
  fd.selectedAwards.forEach((award) => {
    const hasGrade = Boolean(
      (award.grade11 && award.grade11.toString().trim()) ||
        (award.grade12 && award.grade12.toString().trim())
    );

    // If no grades provided, require at least one grade and additional info
    if (!hasGrade) {
      errors[`grade_${award.subjectAwardId}`] =
        "Please provide Grade 11 and/or Grade 12 grade for this subject.";

      if (!award.moreInfo?.trim()) {
        errors[`moreInfo_${award.subjectAwardId}`] =
          "Additional Information is required when grades are not provided.";
      }
    }

    // If grades are present, Additional Information is optional
  });
  return errors;
};

export const validateStep4 = (fd) => {
  const errors = {};
  // Fully optional
  return errors;
};
export const validateStep5 = (fd) => {
  const errors = {};
  // Fully optional
  return errors;
};
export const validateStep6 = (fd) => {
  const errors = {};
  const choices = ["choice1", "choice2", "choice3", "choice4", "choice5"];

  // If award considerations are not shown, choices are not required
  if (!fd.showAwardConsiderations) {
    return errors;
  }

  choices.forEach((choice, index) => {
    if (!fd[choice]?.trim()) {
      errors[choice] = `Choice ${index + 1} is required.`;
    }
  });

  return errors;
};
export const validateStep7 = (fd) => {
  const errors = {};
  fd.affiliations.forEach((affiliation, index) => {
    if (affiliation.selected && affiliation.moreInfoText) {
      if (!affiliation.moreInfo?.trim()) {
        errors[
          `affiliations[${index}].moreInfo`
        ] = `Please provide more info for ${affiliation.name}.`;
      }
    }
  });
  return errors;
};
export const validateStep8 = (fd) => {
  const errors = {};

  if (fd.bursary) {
    if (!fd.bursary_resides_with) {
      errors.bursary_resides_with = "Please select whom you live with.";
    }

    if (
      fd.bursary_resides_with === "Other" &&
      !fd.bursary_resides_with_other?.trim()
    ) {
      errors.bursary_resides_with_other = "Please specify whom you live with.";
    }

    const incomeFields = [
      "bursary_gross_income_father",
      "bursary_gross_income_mother",
      "bursary_gross_income_stepfather",
      "bursary_gross_income_stepmother",
      "bursary_gross_income_applicant",
      "bursary_gross_income_other",
    ];

    const isAtLeastOneFilled = incomeFields.some(
      (field) =>
        fd[field] !== "" && fd[field] !== null && fd[field] !== undefined
    );

    if (!isAtLeastOneFilled) {
      errors.bursary_gross_income_father =
        "At least one income field must be filled.";
    }

    if (!fd.bursary_reason?.trim()) {
      errors.bursary_reason = "Please describe your financial need.";
    }

    if (!fd.bursary_signing_date) {
      errors.bursary_signing_date = "Date is required.";
    }

    if (!fd.bursary_student_signing?.trim()) {
      errors.bursary_student_signing = "Please type your name.";
    }

    if (
      fd.bursary_gross_income_other > 0 &&
      !fd.bursary_gross_income_other_explain?.trim()
    ) {
      errors.bursary_gross_income_other_explain =
        "Please explain other financial support.";
    }
  }

  return errors;
};

export const validateStep9 = (fd) => {
  const errors = {};
  return errors;
};

export const genStepValidators = [
  validateStep1,
  validateStep2,
  validateStep3,
  validateStep4,
  validateStep5,
  validateStep6,
  validateStep7,
  validateStep8,
  validateStep9,
];
